"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_intl_1 = require("react-intl");
const FormattedTime = (props) => {
    const { timeZone: ctxTimeZone, defaultFormats, formats } = (0, react_intl_1.useIntl)();
    const format = formats.time || (defaultFormats.time && defaultFormats.time.justTime);
    const wrappedProps = { ...format, ...props, timeZone: props.timeZone || ctxTimeZone };
    return React.createElement(react_intl_1.FormattedDate, { ...wrappedProps });
};
exports.default = FormattedTime;
